window.validators = {
    exists : function(prop){
        console.log('Checking exists: ' + prop);
        console.log(this);
        return this.validators.hasOwnProperty(prop);
    },
    validate : function (form){
        let valid_form = true;
        let elements = form.querySelectorAll('[data-validator]');
        elements.forEach((el) => {
            //console.log(this.validators);
            console.log('Checking element: ' + el.name);

            let validator = el.getAttribute('data-validator');

            console.log('Validator to use: ' + validator);

            if(this.validators.hasOwnProperty(validator)){
                let valid = this.validators[validator].call(null, el.value);
                if(valid){
                    el.setCustomValidity('');
                } else {
                    el.setCustomValidity('Invalid');
                    valid_form = false;
                }
            } else {
                console.log('Validator not present');
            }
        });

        return valid_form;
    },
    validators : {
        'vin' : function(val){
            console.log('vin validator! ' + val);
            return val.length == 17;
        },
        'digits' : function(val){
            console.log('digits validator! ' + val);
            return ('' + val).match(/^\d+$/g);
        },
        'alpha_numeric' : function(val){
            console.log('alpha_numeric validator! ' + val);
            return ('' + val).match(/^[0-9a-z]+$/gi);
        },
        'required' : function(val){
            console.log('required validator! ' + val);
            if(!val || (val.trim().length == 0) ){
                return false;
            }
            return true;
        }
    }
}
